import { gql } from "@apollo/client";

export const POLESET_FRAGMENT = gql`
  fragment Poleset on Poleset {
    id
    name
    createdAt
    poles {
      id
      length
      color
      radius
    }
  }
`;

export const CREATE_POLESET = gql`
  ${POLESET_FRAGMENT}
  mutation CreatePoleset($name: String!) {
    createPoleset(name: $name) {
      ...Poleset
    }
  }
`;

export const DELETE_POLESET = gql`
  ${POLESET_FRAGMENT}
  mutation DeletePoleset($id: ID!) {
    deletePoleset(id: $id) {
      ...Poleset
    }
  }
`;

export const ADD_POLE_TO_SET = gql`
  ${POLESET_FRAGMENT}
  mutation AddPoleToSet($polesetId: ID!, $poleType: PoleTypeInput!) {
    addPoleToSet(polesetId: $polesetId, poleType: $poleType) {
      ...Poleset
    }
  }
`;

export const DELETE_POLE_FROM_SET = gql`
  ${POLESET_FRAGMENT}
  mutation DeletePoleFromSet($polesetId: ID!, $poleId: ID!) {
    deletePoleFromSet(polesetId: $polesetId, poleId: $poleId) {
      ...Poleset
    }
  }
`;

export const EDIT_POLE_IN_SET = gql`
  ${POLESET_FRAGMENT}
  mutation EditPoleInSet(
    $polesetId: ID!
    $poleId: ID!
    $poleType: PoleTypeInput!
  ) {
    editPoleInSet(polesetId: $polesetId, poleId: $poleId, poleType: $poleType) {
      ...Poleset
    }
  }
`;

export const POLESETS = gql`
  ${POLESET_FRAGMENT}
  query GetPolesetsByUserId($userId: ID!) {
    getPolesetsByUserId(userId: $userId) {
      ...Poleset
    }
  }
`;
